<div *ngIf="loading()" class="d-flex justify-content-center">
  <mat-spinner [diameter]="64" class="mx-auto mt-3"></mat-spinner>
</div>

<div
  *ngIf="!loading()"
  [style]="'--bg-color:' + (booking.meeting_template?.color ?? '#3158e3')"
  class="wrapper text-color-{{ getContrastYIQ(booking.meeting_template?.color ?? '#3158e3') }}"
>
  <div class="container">
    <section cf-loader-container class="personal-information">
      <div class="step personal-information">
        <cf-booking-confirmation
          [eventAddedToCalendar]="false"
          [heading]="'confirmed' | translate"
          [description]="'booking.confirmation_text' | translate: { name: booking.organizer.name }"
          [booking]="$any(booking.meeting_template)"
          [selectedDuration]="selectedDuration"
          [timezone]="booking.timezone"
          [selectedTime]="selectedTime"
          [selectedSlot]="selectedSlot"
          [account]="accountService.account"
          [isPreview]="false"
          [participantsAmount]="booking.count_participants"
        ></cf-booking-confirmation>
      </div>
    </section>

    <cf-booking-footer
      [showLogo]="booking.show_cal_frenzy_logo ?? false"
      [cancellationPolicy]="
        booking.meeting_template && booking.meeting_template.use_cancellation_policy
          ? (booking.meeting_template.cancellation_policy ?? '')
          : ''
      "
    ></cf-booking-footer>
  </div>
</div>
